"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _Theme = require("../constants/Theme");

var _AppConfig = require("../../configs/AppConfig");

var initTheme = (0, _objectSpread2.default)({}, _AppConfig.THEME_CONFIG);

var theme = function theme() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initTheme;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _Theme.TOGGLE_COLLAPSED_NAV:
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        navCollapsed: action.navCollapsed
      });

    case _Theme.SIDE_NAV_STYLE_CHANGE:
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        sideNavTheme: action.sideNavTheme
      });

    case _Theme.CHANGE_LOCALE:
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        locale: action.locale
      });

    case _Theme.NAV_TYPE_CHANGE:
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        navType: action.navType
      });

    case _Theme.TOP_NAV_COLOR_CHANGE:
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        topNavColor: action.topNavColor
      });

    case _Theme.HEADER_NAV_COLOR_CHANGE:
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        headerNavColor: action.headerNavColor
      });

    case _Theme.TOGGLE_MOBILE_NAV:
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        mobileNav: action.mobileNav
      });

    case _Theme.SWITCH_THEME:
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        currentTheme: action.currentTheme
      });

    default:
      return state;
  }
};

var _default = theme;
exports.default = _default;